import { memo } from 'react';
import { useStore } from '@/store';
import { HomePlaceInfo } from '@/store/types';
import { useSpring, animated } from '@react-spring/web';
import styles from './index.module.scss';

interface HotSpotProps {
  place: HomePlaceInfo;
  index: number;
}

const HotSpot = ({ place, index }: HotSpotProps) => {
  const setHomeMode = useStore((state) => state.setHomeMode);
  
  // const spring = useSpring({
  //   from: { scale: 0, opacity: 0 },
  //   to: { scale: 1, opacity: 1 },
  //   // delay: index * 50,
  //   config: {
  //     tension: 180*2,
  //     friction: 12,
  //   }
  // });

  return (
    <animated.div
      className={styles.hotSpot}
      style={{
        // left: place.x,
        // top: place.y,
        // ...spring
        width: 'max-content',
      }}
      onClick={() => setHomeMode(place.entity_id)}
    >
      <div className={styles.hotSpotContent}>
        <div className={styles.images_bg}>
          <img
            src={place.image}
            alt=""
            className={styles.images}
          />
        </div>
        <div className={styles.home_container}>
          <span className={styles.top}>{place.name}</span>
          <span className={styles.bottom}>{place?.biz_info?.scenic_golden_sentences?.[0] || '-'}</span>
        </div>
      </div>
    </animated.div>
  );
};

export default memo(HotSpot); 